<template>
	<footer class="app-footer">
		<div>© 2026 北京银合信科技有限公司. 保留所有权利.</div>
		<a href="https://www.yinhexin.cn/" target="_blank" rel="noopener noreferrer">京ICP备2023003240号</a>
	</footer>
</template>

<script>
export default {
	name: 'AppFooter'
};
</script>
